import { api } from "api/common";
import { createActionsHook } from "react-redux-actions-hook";
import { setToastMessage } from "../app/actions";
import {
  RESEND_INVITE,
  DELETE_INVITE,
  ALL_INVITES,
  INVITE_BREAK_DOWN,
} from "api/constants";
import { InvitesActionType } from "./constants";

export const loadInvites = (data = {}) => {
  return (dispatch, stateFn) => {
    const state = stateFn().invites;
    api(
      `${ALL_INVITES}`,
      {
        method: "POST",
        body: JSON.stringify({ ...state.table, ...data }),
      },
      dispatch
    )
      .then((response) => {
        dispatch(setInvites(response.data));
        dispatch(loadInviteBreakDown());
      })
      .catch((error) => {
        //Handle Error
      });
  };
};
export const setInvites = (invites) => {
  return { type: InvitesActionType.SET_INVITES, invites };
};

export const setEditInvite = (data) => {
  return { type: InvitesActionType.SET_EDIT_INVITE, data };
};

export const setOrderBy = (orderBy) => {
  return { type: InvitesActionType.SET_ORDER_BY, orderBy };
};

export const setPagination = (paging) => {
  return { type: InvitesActionType.SET_PAGING_OPT, paging };
};

export const setFilter = (filters) => {
  return { type: InvitesActionType.SET_FILTER, filters };
};

export const setSearch = (search) => {
  return { type: InvitesActionType.SET_SEARCH_TEXT, search };
};

export const setPageOffset = (offset) => {
  return { type: InvitesActionType.SET_PAGE_OFFSET, offset };
};

export const setBreakDown = (breakDown) => {
  return { type: InvitesActionType.SET_BREAK_DOWN, breakDown };
};

export const resendInvite = (id) => {
  return (dispatch, stateFn) => {
    const state = stateFn().invites;
    api(`${RESEND_INVITE}/${state.editInvite.id}`, { method: "GET" }, dispatch)
      .then(() => {
        // Reload Invites
        dispatch(
          setToastMessage({
            message: `Invite Sent to ${state.editInvite.email}`,
            type: "success",
          })
        );
        dispatch(loadInvites());
      })
      .catch((error) => {
        //Handle Error
        dispatch(
          setToastMessage({
            message: error.message || "Unable to send invitation!",
            type: "error",
          })
        );
      });
  };
};

export const deleteInvite = (id) => {
  return (dispatch, stateFn) => {
    const state = stateFn().invites;
    api(
      `${DELETE_INVITE}/${state.editInvite.id}`,
      { method: "DELETE" },
      dispatch
    )
      .then((success) => {
        // Reload Invites
        dispatch(
          setToastMessage({
            message: "Deleted Invite",
            type: "success",
          })
        );
        dispatch(loadInvites());
      })
      .catch((error) => {
        //Handle Error
        dispatch(
          setToastMessage({
            message: error.message || "Unable to delete invitation",
            type: "error",
          })
        );
      });
  };
};

export const loadInviteBreakDown = () => {
  return (dispatch) => {
    api(`${INVITE_BREAK_DOWN}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(setBreakDown(response.data));
      })
      .catch((error) => {});
  };
};

export default createActionsHook({
  loadInvites,
  deleteInvite,
  resendInvite,
  setEditInvite,
  setOrderBy,
  setPagination,
  setFilter,
  setSearch,
  setPageOffset,
  loadInviteBreakDown,
});
